<template>
    <transition name="fade">
        <div v-if="!privacyPolicyConsent.cookies" id="lgpd-alert-container">
            <div class="header">
                <h6>Política de privacidade</h6>

                <div @click="acceptCookies">
                    <icon name="times" color="var(--secondary-3)" />
                </div>
            </div>

            <p class="text-16 text-weight-bold">
                Nós usamos cookies para personalizar e melhorar a sua experiência no site. Ao continuar navegando, você concorda com a nossa
                <a @click="goToPolicy">Política de Privacidade</a>.
            </p>
            <div class="footer">
                <ci-button @click="acceptCookies" text="Fechar e continuar" block normalCase />
            </div>
        </div>
    </transition>
</template>
<script>
import 'vue-awesome/icons/times'
import { mapState, mapActions } from 'vuex'
export default {
    name: 'LGPDAlert',
    computed: {
        ...mapState(['privacyPolicyConsent']),
    },
    methods: {
        ...mapActions('privacyPolicyConsent', ['acceptCookies']),
        goToPolicy() {
            this.acceptCookies()
            this.$router.push('/privacy-policy')
        },
    },
}
</script>
<style lang="scss" scoped>
#lgpd-alert-container {
    z-index: 99999999999;
    background: var(--primary-3);
    height: 230px;
    width: 500px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    left: 16px;
    bottom: 12px;
    padding: 16px;
    border-radius: 8px;
    -webkit-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.75);

    @media (max-width: 700px) {
        width: 90%;
        left: 5%;
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        h6 {
            color: var(--secondary);
            margin-bottom: 0;
        }

        & > div {
            cursor: pointer;
        }
    }

    p {
        a {
            color: var(--secondary);
            cursor: pointer;
            opacity: 1;
            transition: opacity 0.3s;

            &:hover {
                opacity: 0.6;
                transition: opacity 0.3s;
            }
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
